<template>
<div class="chapter">
<div class="inner_page">
<a id="page3" title="3">
<h1 class="booktitle">Dambuster-in-Chief</h1>
<p class="booksubtitle">The Life of Air Chief Marshal Sir Ralph Cochrane <span class="small">GBE, KCB, AFC</span></p>
<p class="bookauthor">Richard Mead</p>
<div class="image1">
<img alt="image" src="images/Img_3_001.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?038fc5cc